import { getMerchItems } from "./items";
import { useState } from "react";
import { MerchItem } from "./lib";
import { FeaturesFlags } from "helpers";
import { useEnvContext } from "contexts/EnvProvider";
import { Container, Background, GridMerch } from "./styles";
import { useInitialActions } from "./hooks/useInitialActions";
import { useImagePath } from "hooks/useImagePath";
import { merchShopAssets } from "assets/cdn";
import PageTopNav, { ISectionMenuItem } from "../../components/PageTopNav";
import BackToTopButton from "components/PageContent/lib/PageBackToTopButton";
import { useMediaQuery } from "@mui/material";
import { PrivateRoute } from "routes/PrivateRoute";

const MerchShop = () => {
	const isLowWidth = useMediaQuery("(max-width:820px)");
	const [sectionMenuData] = useState<ISectionMenuItem[]>([]);
	const { isFeatureFlagEnabled } = useEnvContext();
	const { getImage } = useImagePath("cdn");
	const items = getMerchItems(getImage);
	useInitialActions();

	return (
		<PrivateRoute isEnabled={isFeatureFlagEnabled(FeaturesFlags.MERCH_SHOP)}>
			<Container>
				<Background
					src={getImage(
						isLowWidth
							? merchShopAssets.banner.mobile
							: merchShopAssets.banner.desktop
					)}
				/>
				<PageTopNav
					navItemColor="#FFE37E"
					sectionMenuData={sectionMenuData}
					isLandingPage
				/>
			</Container>
			<GridMerch>
				{items.map((item, key) => (
					<MerchItem item={item} key={key} />
				))}
			</GridMerch>
			<BackToTopButton
				source="merch_shop_page"
				style={{ position: "relative", marginTop: 0 }}
			/>
		</PrivateRoute>
	);
};

export default MerchShop;
